import React, { Component } from 'react'
import Link from 'gatsby-link'
import { slide as Menu } from 'react-burger-menu'

import './style.css'
import './bm-style.css'

export default class MobileMenu extends Component {
    constructor (props) {
        super(props)
        this.state = {
            menuOpen: false
        }
    }
    closeMenu () {
        this.setState({menuOpen: false})
    }
    showSettings (event) {
        event.preventDefault()
    }
    render() {
        return (
            <div className="mobileMenuContainer">
                {this.props.location.pathname === '/' ?
                null
                :
                (<div className="headerMenu">
                    <Link to="/" className="home" />
                </div>)}
                <Menu
                style={{display:'none'}}
                className="mobileMenu"
                isOpen={this.state.menuOpen}
                right>

                <ul className="menu">
                    <li><Link to="/" className="home" /></li>
                    <li className="blue"><Link to="/who-we-are" activeClassName="blue">Who We Are</Link></li>
                    <li className="orange"><Link to="/our-story" activeClassName="orange">Our Story</Link></li>
                    <li className="pink"><Link to="/what-we-do" activeClassName="pink">What We Do</Link></li>
                    <li className="green"><Link to="/what-you-can-do" activeClassName="green">What You Can Do</Link></li>
                    <li className="blue"><Link to="/our-trustees" activeClassName="blue">Our Trustees</Link></li>
                    <li className="orange"><Link to="/our-supporters" activeClassName="orange">Our Supporters</Link></li>
                    <li className="pink"><Link to="/our-news" activeClassName="pink">Our News</Link></li>
                    <li className="green"><Link to="/contact-us" activeClassName="green">Contact Us</Link></li>
                </ul>
                </Menu>
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/mobileMenu.js